var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2028",
    "data-name": "Rettangolo 2028",
    width: 8.482,
    height: 8.474,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_70078",
    "data-name": "Raggruppa 70078",
    transform: "translate(-356 -235)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1",
    "data-name": "Ellisse 1",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(356 235)",
    fill: "#3f51b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_70077",
    "data-name": "Raggruppa 70077",
    transform: "translate(362.759 241.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_67959",
    "data-name": "Raggruppa 67959",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35838",
    "data-name": "Tracciato 35838",
    d: "M0,.457C.009.432.019.407.028.381A.549.549,0,0,1,.91.136c.033.029.064.061.1.092L4.167,3.391a.517.517,0,0,1,.056.082l.036,0a.578.578,0,0,1,.057-.081l3.2-3.2a.549.549,0,0,1,.844.7,1.137,1.137,0,0,1-.09.1L5.093,4.166c-.023.023-.05.043-.094.081a.768.768,0,0,1,.091.066l3.2,3.2a.55.55,0,0,1,.179.508.536.536,0,0,1-.384.435c-.013,0-.025.011-.037.016H7.8a1.033,1.033,0,0,1-.389-.283q-1.55-1.553-3.1-3.1c-.023-.023-.046-.044-.079-.075-.027.031-.047.058-.07.081Q2.607,6.652,1.051,8.21a.983.983,0,0,1-.371.265H.431a.557.557,0,0,1-.3-.187A2.312,2.312,0,0,1,0,8.027V7.845a.835.835,0,0,1,.26-.4q1.568-1.563,3.134-3.13a.73.73,0,0,1,.1-.067c-.05-.039-.078-.057-.1-.081Q1.826,2.6.262,1.041A.858.858,0,0,1,0,.639V.457",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconBlue);
export default __webpack_public_path__ + "static/media/crossIconBlue.162a036d5dad6ad3cc3affe47f707f95.svg";
export { ForwardRef as ReactComponent };